import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Worktable = () => {

    const workimages = [
        {
            image: "img7.png",
            title: " Learn Space ",
            bg: "#373737",
            topic: "Full Stack Development",
            category: "development",
            link: "https://learn-space-chi.vercel.app/"
        },
        {
            image: "img6.png",
            title: " Anime - Valley ",
            bg: "#373737",
            topic: "Development & Design",
            category: "development",
            link: "https://anime-valley-gamma.vercel.app/"
        },
        {
            image: "img8.png",
            title: " Panache Management ",
            bg: "#48494A",
            topic: "Full Stack Development",
            category: "development",
            link: "https://panache2025.vercel.app/"
        },
        {
            image: "img5.png",
            title: " CharmCloset ",
            bg: "#373737",
            topic: "Design & Development",
            category: "development",
            link: "https://mern-ecommerce-nyxd.onrender.com/"
        },
        {
            image: "img1.png",
            title: " Portfolio ",
            bg: "#48494A",
            topic: "Design & Development",
            category: "development",
            link: "https://gagan-portfolio.onrender.com/"
        },
        {
            image: "img2.png",
            title: " Coffee ",
            bg: "#363637",
            topic: "Commercial & Development",
            category: "development",
            link: "https://gagan-deepp.github.io/coffee/"
        },
        {
            image: "img3.png",
            title: " Cafe ",
            bg: "#B1A994",
            topic: "Design & Development",
            category: "design",
            link: "https://gagan-deepp.github.io/cafe/"
        },
        {
            image: "img4.png",
            title: " Raunak ",
            bg: "#626D6E",
            topic: "Design & Development",
            category: "development",
            link: "https://gagan-deepp.github.io/Portfolio/"
        },
    ]

    const buttons = [
        {
            name: "All",
            category: "all"
        },
        {
            name: "Development",
            category: "development"
        },
        {
            name: "Design",
            category: "design"
        },
    ]

    const workVariant = {
        initial: {
            opacity: 0,
            y: 300
        },

        animate: {
            opacity: 1,
            y: 0,
            transition: {
                delay: 0.02,
                ease: [0.65, 0, 0.35, 1]
            }
        }
    }

    const [categoryButton, setCategoryButton] = useState("all");
    const [imageArray, setImageArray] = useState(workimages);

    const setFilteredArray = (category) => {
        setCategoryButton(category)

        categoryButton === "all" ? setImageArray(workimages) :
            setImageArray(workimages.filter(imgs => imgs.category === category))
    }

    useEffect(() => {
        setFilteredArray(categoryButton)
        // eslint-disable-next-line
    }, [categoryButton])
    return (
        <WorkTableDiv>

            <motion.div
                initial={{ scale: 0, opacity: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    ease: [0.65, 0, 0.35, 1],
                    duration: 1,
                    delay: 1
                }}
                className="titleColumn">
                {
                    buttons.map((button, index) => (
                        <motion.div key={index}
                            whileHover={{ scale: 1.09 }}
                            whileTap={{ scale: 0.9 }}
                            transition={
                                {
                                    duration: 0.15,
                                    ease: [0.65, 0, 0.35, 1]
                                }
                            }
                            className='titleName'
                            onClick={() => { setCategoryButton(button.category) }}
                        >
                            <motion.span>
                                {button.name}
                            </motion.span>
                        </motion.div>
                    ))
                }
            </motion.div>

            <MyWork className="myWork">

                <div className="myWorkContainer">
                    {
                        imageArray.map((image, index) => (
                            <WorkContent key={index}
                                className='workContent'>

                                <motion.div
                                    variants={workVariant}
                                    initial="initial"
                                    whileInView="animate"
                                    viewport={{ once: true }}
                                    className="workContainer">

                                    <Link to={image.link} target='_blank'>
                                        <div className="workImage" style={{ background: image.bg }}>
                                            <div className="imgContainer">
                                                <img src={`/work/${image.image}`} alt="" />
                                            </div>
                                        </div>

                                        <div className="workName">
                                            <h3> {image.title} </h3>

                                            <div className="line" />
                                        </div>

                                        <div className="worktopic">
                                            <span> {image.topic} </span>
                                        </div>
                                    </Link>
                                </motion.div>
                            </WorkContent>
                        ))
                    }
                </div>

            </MyWork>

        </WorkTableDiv>
    )
}

export default Worktable

const WorkContent = styled(motion.div)`
min-height: 90vh;
overflow: hidden;

@media only screen and (max-width: 1260px) {
    min-height: 80vh !important;
}

@media only screen and (max-width: 1100px) {
    min-height: 70vh !important;
}

@media only screen and (max-width: 895px) {
    min-height: 67vh !important;
}

@media only screen and (max-width: 780px) {
    min-height: 60vh !important;
}

@media only screen and (max-width: 680px) {
    min-height: 50vh !important;
}

@media only screen and (max-width: 600px) {
    min-height: 70vh !important;
}

@media only screen and (max-width: 475px) {
    min-height: 60vh !important;
}
@media only screen and (max-width: 386px) {
    min-height: 57vh !important;
}

.workContainer{
    width: 100%;
    height: 100%;
    position: relative;

        a{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            row-gap: 5vh;

            .workName{
                display: flex;
                flex-direction:column;
                row-gap: 1rem;
        
                h3{
                    font-size: 3rem;
                    font-weight: 400;
                    font-family: var(--font6);
                    
                    @media only screen and (max-width: 780px) {
                        font-size: 2.25rem !important;
                        font-weight: 300 !important;
                    }
                }
        
                .line
            }

            .worktopic{
                span{
                    font-size: 1.25rem;
                    font-weight: 400;
                    letter-spacing: 1px;

                    @media only screen and (max-width: 780px) {
                        font-size: 1rem !important;
                    }
                }
            }
        }
    }
`

const MyWork = styled.div`
    width: 100%;

    .myWorkContainer{
        display: grid;
        grid-row-gap: 20rem;
        grid-column-gap: 5rem;
        grid-template-columns: repeat(2 , minmax(15rem , 1fr));
        
        @media only screen and (max-width: 600px) {
            grid-template-columns: repeat(1 , minmax(15rem , 1fr)) !important;
        }
        @media only screen and (max-width: 680px) {
            grid-row-gap: 8rem;
            grid-column-gap: 3rem;
        }

        .workImage{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items:center;
            &:hover{
                transition: all 300ms ease-in-out;
                transform: scale(1.05);
            }

            .imgContainer{
                width: 90%;

                @media only screen and (max-width: 300px) {
                    width: 80% !important;
                }
                
                img{
                    border-radius: 0.5rem;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: all 250ms (0.65, 0, 0.35, 1);
                }
            }

        }
    }
`

const WorkTableDiv = styled.div`
    margin: auto;
    width: 90%;
    overflow: hidden;
    padding: 10vh 0;
    display: flex;
    flex-direction: column;
    row-gap: 10vh;
    
    @media only screen and (max-width: 600px) {
        width: 80% !important;
    }
`